<template>
  <v-dialog fullscreen v-model="dialog" transition="dialog-bottom-transition">
    <v-card>

      <v-toolbar fixed dark color="primary">
        <v-btn icon @click="hide">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{defaultPlan ? 'Editar' : 'Crear'}} Plan</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="showDelete" depressed v-if="defaultPlan">
          <v-icon size="18" class="mr-1">fa-trash</v-icon>
          Eliminar
        </v-btn>
        <v-btn :disabled="!valid" :loading="loading" @click="savePlan" color="primary" depressed>
          <v-icon class="mr-2">fa-save</v-icon>
          Guardar
        </v-btn>
      </v-toolbar>

      <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-layout wrap justify-center pa-4 mt-4>
                <v-flex xs12 md8 xl6 text-xs-center>
                  <v-layout wrap mt-4>

                    <v-flex xs12 md9 px-1 py-0>
                      <v-text-field
                          box
                          :rules="nameRules"
                          v-model="name"
                          label="Nombre del Plan"
                          placeholder="Ej. Plan Base"
                      />
                    </v-flex>

                    <v-flex xs12 md3 px-1 py-0>
                      <v-switch v-model="recommended"
                        label="Destacado"
                        />
                    </v-flex>

                    <v-flex xs12 px-1 py-0>
                      <v-textarea
                          v-model="description"
                          :rules="descriptionRules"
                          clearable
                          label="Descripción (Opcional)"
                          placeholder="Ej. El mejor plan para consultas particulares"
                          box />
                    </v-flex>

                    <v-flex xs12 md6 px-1 py-0>
                      <v-text-field
                          :rules="amountRules"
                          prefix="UF"
                          prepend-inner-icon="fa-dollar-sign"
                          label="Valor del Plan"
                          type="number"
                          v-model="amount"
                          box
                        />
                    </v-flex>

                    <v-flex xs12 md6 px-1 py-0>
                      <v-text-field
                          :rules="maxSpecialistsRules"
                          prepend-inner-icon="fa-users"
                          label="Max. cuentas profesionales"
                          v-model="max_specialists"
                          type="number"
                          box
                      />
                    </v-flex>

                    <v-flex xs12 md6 px-1 py-0>
                      <v-text-field
                          :rules="trialRules"
                          prepend-inner-icon="fa-calendar-alt"
                          label="Días de prueba"
                          type="number"
                          v-model="trial"
                          box
                        />
                    </v-flex>

                    <v-flex xs12 md6 px-1 py-0>
                      <provider-picker
                          ref="providerPicker"
                          box
                          label="Solo disponible para"
                          @change="provider = $event" />
                    </v-flex>

                    <v-flex xs12 md6 px-1 py-0>
                      <v-select
                        box
                        :disabled="!!provider"
                        :readonly="max_specialists > 1"
                        v-model="target"
                        :items="targetOptions"
                        item-disabled="disabled"
                        :hint="max_specialists > 1 ? 'Solo centros pueden tener mas de 1 cuenta profesional' : ''"
                        label="Disponibilidad"
                        />
                    </v-flex>

                    <v-flex xs12 md6 px-1 py-0>
                      <v-text-field
                        box
                        :disabled="target !== 'institution'"
                        type="number"
                        :rules="branchRules"
                        v-model="max_branch_offices"
                        :hint="max_specialists > 1 ? 'Solo centros pueden tener sucursales' : ''"
                        label="Max. sucursales"
                        />
                    </v-flex>

                    <v-flex xs12 px-1 py-0>
                      <v-select
                        box
                        v-model="features"
                        :items="featureOptions"
                        multiple
                        label="Características especiales"
                        />
                    </v-flex>

                    <v-flex xs12 >
                      <v-alert outline :value="true" color="primary" type="info">
                        <small>Este plan estará disponible <b>{{availableFor}}</b>.</small>
                      </v-alert>
                    </v-flex>

                  </v-layout>
                </v-flex>


              </v-layout>

            </v-container>
          </v-form>
      </v-card-text>


    </v-card>
    <kimsa-confirm
        ref="deleteDialog"
        title="Eliminar Plan"
        content="¿Confirmas que deseas eliminar este plan?"
        :loading="deleting"
        @confirm="deletePlan"
      />
  </v-dialog>
</template>

<script>
import {ApiUtils} from "@/utils/ApiUtils";
import ProviderPicker from "../../../components/admin/ProviderPicker";
import KimsaConfirm from "../../common/KimsaConfirm";

export default {
  name: "PlanEditor",
  components: {KimsaConfirm, ProviderPicker},
  data(vm){
    return {

      defaultPlan: null,

      loading: false,
      deleting: false,
      dialog: false,
      valid: false,

      name: '',
      recommended: false,
      description: '',
      amount: 0,
      max_branch_offices: 1,
      max_specialists: 1,
      provider: null,
      trial: 14,
      target: 'institution',
      features: [],

      targetOptions: [
        /*{value: 'all', text: 'Cualquier paciente', disabled: vm.max_specialists > 1},*/
        {value: 'individual', text: 'Consultas Individuales', disabled: vm.max_specialists > 1},
        {value: 'institution', text: 'Empresas'}
      ],

      featureOptions: [
        {value: 'public_profile', text: 'Perfil Público'},
        {value: 'vc', text: 'Video Atención'},
        {value: 'payments', text: 'Cobro de citas en línea'},
      ],

      nameRules: [
          v => !!v && v.length > 4 || 'Campo requerido (min: 5 caracteres)'
      ],
      descriptionRules: [
          v => (!v || (!!v && v.length >= 10)) || 'Min. 10 caracteres'
      ],
      amountRules: [
          v => v >= 0.2 && v < 100 || 'Valor inválido (min: 0.2, max: 100)'
      ],
      trialRules: [
          v => (Number.isInteger(Number(v)) && v >= 0 && v <= 90) || 'Valor inválido (min: 0, max: 90)'
      ]
    }
  },
  methods:{
    showDelete(){
      const vm = this
      vm.$refs.deleteDialog.show()
    },
    async savePlan(){
      const vm = this

      let payload = {
        name: vm.name,
        recommended: vm.recommended ? 1 : 0,
        description: vm.description,
        amount: vm.amount,
        max_specialists: vm.max_specialists,
        max_branch_offices: vm.max_branch_offices,
        trial_period_days: vm.trial,
        target: vm.target,
        features: vm.features
      }

      if(vm.provider){
        payload.service_provider_id = vm.provider.value
      }

      vm.loading = true
      const response = vm.defaultPlan ?
          await ApiUtils.makePatch(`subscriptions/plans/${vm.defaultPlan.id}`, null, payload)
          : await ApiUtils.makePost('subscriptions/plan', payload)
      vm.loading = false

      if(!response.ok){
        const json = await response.json()
        const message = json.message || 'Ocurrió un error creando el plan'
        return vm.toast(message, 'error')
      }

      vm.toast('¡Plan guardado!')
      vm.$emit('saved')
      vm.hide()

    },
    async deletePlan(){
      const vm = this

      if(!vm.defaultPlan){
        return
      }

      if(vm.deleting) return

      vm.deleting = true
      const response = await ApiUtils.makeDelete(`subscriptions/plans/${vm.defaultPlan.id}`)
      vm.deleting = false

      if(!response.ok){
        const json = await response.json()
        const message = json.message || 'Ocurrió un error eliminando el plan'
        return vm.toast(message, 'error')
      }

      vm.toast('¡Plan eliminado!', 'error')
      vm.$emit('deleted')
      vm.$refs.deleteDialog.hide()
      vm.hide()

    },
    reset(){
      const vm = this
      vm.defaultPlan = null
      vm.name = ''
      vm.recommended = false
      vm.description = ''
      vm.amount = 0
      vm.max_specialists = 1
      vm.max_branch_offices = 1
      vm.target = 'institution'
      vm.provider = null
      vm.trial = 14
      vm.features = []
      vm.$refs.providerPicker.model = null
    },

    setDefaults(){

      const vm = this
      let plan = vm.defaultPlan
      if(!plan) return vm.reset()

      vm.name = plan.name
      vm.recommended = plan.recommended
      vm.description = plan.description
      vm.amount = plan.amount
      vm.target = plan.target
      vm.max_specialists = plan.max_specialists
      vm.max_branch_offices = plan.max_branch_offices
      vm.provider = plan.service_provider || null
      vm.trial = plan.trial_period_days
      vm.features = plan.features.map(feat => {
        return {value: feat, text: ''}
      })
      vm.$refs.providerPicker.model = plan.service_provider ? {
        text: plan.service_provider.name,
        value: plan.service_provider.id
      } : null
    },

    show(planToEdit = null){
      const vm = this
      vm.defaultPlan = planToEdit
      vm.$nextTick(function(){
        vm.dialog = true
      })

    },
    hide(){
      const vm = this
      vm.dialog = false
      vm.reset()
    }
  },
  computed:{
    branchRules(){
      const vm = this
      const min = vm.target === 'institution' ? 1 : 0;
      return [
        v => v >= min || `Campo requerido (min: ${min})`
      ]
    },
    maxSpecialistsRules(){
      const vm = this
      const max = vm.target === 'individual' ? 1 : 100;
      return [
        v => (Number.isInteger(Number(v)) && v > 0 && v <= max) || `Valor inválido (min: 1, max: ${max})`
      ]
    },
    availableFor(){
      const vm = this
      if(vm.provider){
        return 'sólo para el paciente seleccionado'
      }

      if(vm.target === 'all'){
        return 'para todos los pacientes'
      }

      if(vm.target === 'individual'){
        return 'sólo para cuentas individuales'
      }

      return 'sólo para cuentas empresa'

    }
  },
  watch:{
    provider(val){
      const vm = this
      if(!val) return
      const { data: provider } = val
      vm.target = provider.type
    },
    target(val){
      if(val === 'individual'){
        this.max_branch_offices = 0
        this.max_specialists = 1
      }else{
        this.max_branch_offices = 5
        this.max_specialists = 5
      }
    },
    defaultPlan(val){
      if(val) this.setDefaults()
    }
  }
}
</script>

<style scoped>

</style>
